import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { IGenericError, ErrorResponse } from '../../../../core/models/generic-models';
import { UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IValidateMobileRequest } from '../../../../core/models/validate-mobile.model';
import * as signup from '../../actions/signup.actions';
import * as login from '../../actions/login.actions';
import * as checkRegistration from '../../actions/check-if-registered.actions';

import * as signupSelector from '../../selectors/signup.selectors';
import { ISignupRequest } from '../../models/signup.model';
import { IRegistrationLoginRequest } from '../../models/registration-login.model';

@Component({
  selector: 'app-general-link',
  templateUrl: './general-link.component.html',
  styleUrls: ['./general-link.component.css']
})
export class GeneralLinkComponent implements OnInit {
  isSignUpLoading$: Observable<boolean>;
  signupFailure$: Observable<IGenericError<ErrorResponse>>;
  getCustomerHomeAddressSubs: Subscription = new Subscription();
  signupForm: any;
  existingMemberCheck: boolean;
  signinForm: any;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.existingMemberCheck = false;

    this.signupForm = this.fb.group({
      firstname: new UntypedFormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(15)]),
      lastname: new UntypedFormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(15)]),
      mobile: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)])
    });

    this.signinForm = this.fb.group({
      mobileSignin: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]+$'),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
      passcode: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(4), Validators.maxLength(4)])
    });
  }

  goToPasscode() {
    const req: ISignupRequest = {
      dialingCode: '+27',
      mobileNumber: this.signupForm.value.mobile,
      firstName: this.signupForm.value.firstname,
      lastName: this.signupForm.value.lastname,
      emailAddress: '',
      generalInvitationLink: '',
      ipAddress: sessionStorage.getItem('ipAddress')
    };
    this.store.dispatch(signup.loadSignupRequest({ request: req }));
    this.store.dispatch(checkRegistration.checkRegisterRequiredRequest({ request: req }));
    this.isSignUpLoading$ = this.store.select(signupSelector.getSignupIsLoading);
    this.signupFailure$ = this.store.select(signupSelector.getSignupFailure);
  }

  signIn() {
  }

  existingMember() {
    this.existingMemberCheck = true;
  }

  newMember() {
    this.existingMemberCheck = false;
  }

  get passcode() {
    return this.signinForm.get('passcode');
  }

  get mobileSignin() {
    return this.signinForm.get('mobileSignin');
  }

  get mobile() {
    return this.signupForm.get('mobile');
  }

  get firstname() {
    return this.signupForm.get('firstname');
  }

  get lastname() {
    return this.signupForm.get('lastname');
  }
}
